import classNames from "classnames"
import React from "react"
import { useLabels } from "../../../../contents/hooks"
import PaymentMethodBox from "../PaymentMethodBox"

export interface PaymentMethodsBoxProps {
  enabledPaymentProviders: string[]
  providerId?: string
  onProviderIdChange: (providerId: string) => void
}

const PaymentMethodsBox = ({
  enabledPaymentProviders,
  providerId,
  onProviderIdChange,
}: PaymentMethodsBoxProps) => {
  const { getLabel } = useLabels()
  const paymentMethods = [
    {
      providerId: "stripe",
      enabled: true,
      label: getLabel("payment", "payment-stripe"),
      icons: [
        "/images/payments/visa.svg",
        "/images/payments/mastercard.svg",
        "/images/payments/amex.svg",
        "/images/payments/google-pay-logo.svg",
        "/images/payments/apple-pay-payment-mark.svg",
      ],
      iconsWidth: 34,
    },
    {
      providerId: "paypal",
      enabled: true,
      label: getLabel("payment", "payment-paypal"),
      icons: ["/images/payments/paypal.svg"],
    },
    {
      providerId: "satispay",
      enabled: enabledPaymentProviders.includes("satispay"),
      label: getLabel("payment", "payment-satispay"),
      icons: ["/images/payments/satispay_logo.svg"],
    },
    {
      providerId: "klarna",
      enabled: enabledPaymentProviders.includes("klarna"),
      label: getLabel("payment", "payment-klarna"),
      icons: ["/images/payments/klarna.svg"],
    },
    {
      providerId: "currier",
      enabled: enabledPaymentProviders.includes("currier"),
      label: getLabel("payment", "payment-currier"),
      icons: [],
      // icons: ["/images/payments/currier.svg"],
    },
    {
      providerId: "pay-in-store",
      enabled: enabledPaymentProviders.includes("pay-in-store"),
      label: getLabel("payment", "pay-in-store"),
      icons: [],
      // icons: ["/images/payments/pay-in-store.svg"],
    },
  ]
  return (
    <div>
      {paymentMethods.map((x) => (
        <PaymentMethodBox
          id={`payment-method-${x.providerId}`}
          className={classNames("my-3", {
            "!hidden": !x.enabled,
          })}
          key={x.providerId}
          selected={x.providerId === providerId}
          onSelect={() => onProviderIdChange(x.providerId)}
          label={x.label}
          icons={x.icons}
          iconsWidth={x.iconsWidth}
        />
      ))}
    </div>
  )
}

export default PaymentMethodsBox
